export default "__VITE_ASSET__Cv$gVLov__"